const HowToLearnDetailHeaderSkeleton: React.FC = () => {
  return (
    <div className="px-4 md:px-6 lg:px-10 xl:px-0 xl:max-w-[1200px] mx-auto w-full md:pt-12 pt-4">
      <div className="w-full">
        <div className="flex-col w-full flex md:flex-row gap-x-12">
          <div className="w-0 md:w-[223px] lg:w-[371px] grow shrink-0 relative aspect-video overflow-hidden">
            <div className="w-full h-full bg-fds-disable animate-pulse" />
          </div>

          <div className="w-full flex flex-col justify-center">
            <div className="h-7 md:h-9 w-3/4 bg-fds-disable rounded-md animate-pulse" />

            <div className="lg:flex md:mt-6 mt-4 gap-x-2 grid grid-cols-3">
              {Array.from({ length: 3 }).map((_, index) => (
                <div
                  key={index}
                  className="flex xl:w-[203px] w-full items-center justify-between rounded-8 bg-fds-brand-light px-2.5 py-2.5 md:px-4 md:py-3.5"
                >
                  <div className="flex flex-col items-center md:items-start justify-center w-full gap-1.5">
                    <div className="h-5 md:h-6 w-10 bg-fds-disable rounded animate-pulse" />
                    <div className="h-3 md:h-4 w-14 md:w-16 bg-fds-disable rounded animate-pulse" />
                  </div>
                  <div className="w-10 h-10 bg-fds-disable rounded animate-pulse hidden md:block shrink-0" />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="relative md:mb-8 mb-4 mt-4 flex justify-center items-center flex-col">
        <div className="w-full space-y-2">
          <div className="h-4 w-full bg-fds-disable rounded animate-pulse" />
          <div className="h-4 w-5/6 bg-fds-disable rounded animate-pulse" />
          <div className="h-4 w-3/4 bg-fds-disable rounded animate-pulse" />
        </div>
      </div>
    </div>
  );
};

export default HowToLearnDetailHeaderSkeleton;
